// extracted by mini-css-extract-plugin
export default {"page-layout":"Sels1","pageLayout":"Sels1","content":"wNryr"};